import { render, staticRenderFns } from "./Accessory.vue?vue&type=template&id=0911b3b1&"
import script from "./Accessory.vue?vue&type=script&lang=js&"
export * from "./Accessory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports